module.exports = __webpack_public_path__ + "static/media/agent1.7217bb34.jpg";